export class ContactType {
    id: number;
    type: string;
 }
